import { formatMessage } from './formatMessage';

interface ILabelsContainer {
  labels: {
    [key: string]: {
      text: string;
      title: string;
    };
  };
}

/**
 * Dado un nombre de etiqueta, devuelve el texto que esa etiqueta contiene en
 * el idioma actual. En este momento, lo único que hace realmente esta función
 * es devolver la variable del window con el mismo nombre que se está
 * pidiendo.
 *
 * La idea de implementar esta función, es que en un futuro la fuente de la
 * que provienen las labels pueda ser más diversa.
 *
 * Permite el pasaje de tokens para el reemplazo automático de los mismos.
 *
 * @example
 *
 * // Suponemos la etiqueta msgUsu = { text: 'Usuario <TOK1>', title: 'Usuario <TOK1>' }
 *
 * getLabel('msgUsu' , {
 *   text: {
 *     TOK1: 'admin',
 *   },
 *   title: {
 *     TOK1: 'no disponible',
 *   }
 * })
 */
export function getLabel(
  name: string,
  replaceTokens?: {
    text?: Record<string, string>;
    title?: Record<string, string>;
  },
) {
  const label = {
    ...((window as unknown as ILabelsContainer).labels[name] ?? {
      text: `Not preloaded: ${name}`,
      title: `Not preloaded: ${name}`,
    }),
  };

  if (replaceTokens?.text !== undefined)
    label.text = formatMessage(label.text, replaceTokens.text);
  if (replaceTokens?.title !== undefined)
    label.title = formatMessage(label.title, replaceTokens.title);

  return label;
}
